
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { Edit, Trash2 } from "lucide-react";
import { type Book } from "./types";

interface BookTableProps {
  books: Book[];
  onEdit: (book: Book) => void;
  onDelete: (id: string) => void;
}

export function BookTable({ books, onEdit, onDelete }: BookTableProps) {
  if (books.length === 0) {
    return (
      <TableRow>
        <TableCell colSpan={6} className="text-center py-4">
          No books found
        </TableCell>
      </TableRow>
    );
  }

  return (
    <>
      {books.map((book) => (
        <TableRow key={book.id}>
          <TableCell>{book.order || "—"}</TableCell>
          <TableCell className="font-medium">{book.title}</TableCell>
          <TableCell>{book.author}</TableCell>
          <TableCell>{book.category}</TableCell>
          <TableCell>
            {book.reading_time ? `${book.reading_time} min` : "N/A"}
          </TableCell>
          <TableCell className="text-right space-x-2">
            <Button
              variant="outline"
              size="sm"
              onClick={() => onEdit(book)}
            >
              <Edit className="h-4 w-4" />
            </Button>
            <Button
              variant="outline"
              size="sm"
              className="text-red-500 border-red-500 hover:bg-red-50"
              onClick={() => onDelete(book.id)}
            >
              <Trash2 className="h-4 w-4" />
            </Button>
          </TableCell>
        </TableRow>
      ))}
    </>
  );
}
